const FLASH_ENTER_IDS = new Set(["flashEnter", "flashBoth"]);

export function normalizePageTransitionId(id) {
	const v = id || "none";
	return v;
}

export function invertPageTransition(t) {
	const id = normalizePageTransitionId(t);
	if (id === "slideLeft") return "slideRight";
	if (id === "slideRight") return "slideLeft";
	if (id === "slideUp") return "slideDown";
	if (id === "slideDown") return "slideUp";
	if (id === "flashExit") return "flashEnter";
	if (id === "flashEnter") return "flashExit";
	if (id === "flashBoth") return "flashBoth";
	return id;
}

export function isFlashEnterTransition(id) {
	return FLASH_ENTER_IDS.has(normalizePageTransitionId(id));
}

export function computePlayPageTransition({ fromIndex, toIndex, pages }) {
	const list = Array.isArray(pages) ? pages : [];
	const durAt = (idx) => list[idx]?.transitionDuration ?? 350;
	if (toIndex > fromIndex) {
		const pg = list[fromIndex];
		const trans = normalizePageTransitionId(pg?.transitionToNext || "none");
		if (trans === "flashExit") return { needsExitFlash: true, playTransitionType: "none", durationMs: durAt(fromIndex) };
		if (trans === "flashEnter") return { needsExitFlash: false, playTransitionType: "flashEnter", durationMs: durAt(fromIndex) };
		if (trans === "flashBoth") return { needsExitFlash: true, playTransitionType: "flashEnter", durationMs: durAt(fromIndex) };
		return { needsExitFlash: false, playTransitionType: trans, durationMs: durAt(fromIndex) };
	}
	const pg = list[toIndex];
	const trans = invertPageTransition(normalizePageTransitionId(pg?.transitionToNext || "none"));
	if (trans === "flashExit") return { needsExitFlash: true, playTransitionType: "none", durationMs: durAt(toIndex) };
	if (trans === "flashEnter") return { needsExitFlash: false, playTransitionType: "flashEnter", durationMs: durAt(toIndex) };
	if (trans === "flashBoth") return { needsExitFlash: true, playTransitionType: "flashEnter", durationMs: durAt(toIndex) };
	return { needsExitFlash: false, playTransitionType: trans, durationMs: durAt(toIndex) };
}
